import { META } from "@/content/meta";
import { usePageMeta } from "@/hooks/usePageMeta";
import { Hero } from "@/components/home/Hero";
import { Marquee } from "@/components/home/Marquee";
import { ValueFigs } from "@/components/home/ValueFigs";
import { FeaturedWork } from "@/components/home/FeaturedWork";
import { ServicesOverview } from "@/components/home/ServicesOverview";
import { HowItWorks } from "@/components/home/HowItWorks";
import { WebsiteCheck } from "@/components/home/WebsiteCheck";
import { Testimonials } from "@/components/home/Testimonials";
import { FAQSection } from "@/components/home/FAQSection";
import { FinalCTA } from "@/components/site/FinalCTA";

export default function Home() {
  usePageMeta(META.home);
  return (
    <>
      <Hero />
      <Marquee />
      <ValueFigs />
      <FeaturedWork />
      <ServicesOverview />
      <HowItWorks />
      <WebsiteCheck />
      <Testimonials />
      <FAQSection />
      <FinalCTA />
    </>
  );
}
